// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import {getMerchant, useIncomingPayment} from '@tectonics/prs/incoming-payment';

type Props = {
  children: Node,
};

export function NupayInstructions(): Node {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  return (
    <Root>
      <DisplayTitleInformation>
        Pague com segurança, sem compartilhar os dados do cartão.
      </DisplayTitleInformation>
      <BulletPointsInformation>
        <DisplayInformation>
          O pagamento é feito no app do Nubank.
        </DisplayInformation>
        <DisplayInformation>
          Você escolhe como pagar com <b> saldo da conta, crédito </b> ou com <PurpleBold>limite adicional de NuPay em até 24x</PurpleBold>.
        </DisplayInformation>
        <DisplayInformation>
          Após a confirmação, você volta para {merchant.name} e sua compra é concluída.
        </DisplayInformation>
      </BulletPointsInformation>
      <DisplayAvailabilityInformation>
          Disponível para clientes Nubank.
      </DisplayAvailabilityInformation>
    </Root>
  );
}

function DisplayTitleInformation({children}: Props): Node {
  return (
    <InformationBox>
      <TitleInfo>
        {children}
      </TitleInfo>
    </InformationBox>
  );
}

function DisplayInformation({children}: Props): Node {
  return (
    <li>
      <InformationBox>
        <Info>
          {children}
        </Info>
      </InformationBox>
    </li>
  );
}
function DisplayAvailabilityInformation({children}: Props): Node {
  return (
    <InformationBox>
      <AvailabilityInfo>
        {children}
      </AvailabilityInfo>
    </InformationBox>
  );
}


const Root = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 4px 20px;
`;

const InformationBox = styled.div`
  width: 100%;
  color: #5e5e5e;
  display: flex;
  font-style: normal;
  font-size: 14px;
  line-height: 1.9em;
  letter-spacing: -0.01em;
  align-items: center;
  padding: 12px 14px;
`;

const Info = styled.div`
  width: 100%;
  display: inline-block;
  font-style: normal;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.01em;
`;

const TitleInfo = styled.div`
  width: 100%;
  display: inline-block;
  font-style: normal;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: -0.01em;
`;

const AvailabilityInfo = styled.div`
  width: 100%;
  display: inline-block;
  font-style: normal;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.01em;
`;

const PurpleBold = styled.span`
    font-weight: bold;
    color: #7b10c5;
`;

const BulletPointsInformation = styled.ul`
    padding-inline-start: 25px;
`;
